// extracted by mini-css-extract-plugin
export default {"checkBox":"Toggle_checkBox__TrXQs","input":"Toggle_input__0RDKO","disabled":"Toggle_disabled__GJ2eM"};